import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Tooltip from '../tooltip/Tooltip.jsx';
import s from './MapZoomControls.module.scss';

const MapZoomControls = ({ zoomIn, zoomOut, zoomCenter, resetNorth }) => (
    <div className={s.zoomControls}>
        <div className={s.zoomTop} />
        <div className={classNames(s.zoomIn, 'icon-add')} onClick={zoomIn}>
            <Tooltip arrowPosition="left" text="Zoom in (+)" />
        </div>
        <div className={classNames(s.zoomOut, 'icon-collapse')} onClick={zoomOut}>
            <Tooltip arrowPosition="left" text="Zoom out (-)" />
        </div>
        <div className={classNames(s.zoomCenter, 'icon-zoom-to-centre')} onClick={zoomCenter}>
            <Tooltip arrowPosition="left" text="Zoom to center" />
        </div>
        <div className={s.resetNorth} onClick={resetNorth}>
            <img className={s.resetNorthIcon} src="https://content.locuslabs.com/vms-ui/map-note-icons/north-alignment.svg" alt="Reset North Icon" />
        </div>
        <div className={s.zoomBottom} />
    </div>
);

MapZoomControls.propTypes = {
    zoomIn: PropTypes.func.isRequired,
    zoomOut: PropTypes.func.isRequired,
    zoomCenter: PropTypes.func.isRequired,
    resetNorth: PropTypes.func.isRequired,
};

export default MapZoomControls;
